module.exports = [
  {
    id: 'calendar01',
    link: 'https://www.tpte.tw/en/',
    image_url: 'https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2023_TPTE_BN.jpg',
    content: "Taipei Travel Expo"
  },
  {
    id: 'calendar02',
    link: 'https://tpemombaby-fair.top-link.com.tw/',
    image_url: 'https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2023_tpemombaby_BN.jpg',
    content: "TopLink Baby & Mommy Expo"
  },
  {
    id: 'calendar03',
    link: 'https://taipeifood.top-link.com.tw/',
    image_url: 'https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2023_taipeifood_BN.jpg',
    content: "International Food and Catering Expo"
  },
  {
    id: 'calendar04',
    link: 'https://www.tte.tw/en/',
    image_url: 'https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2023_TTE_BN.jpg',
    content: "Taipei Tiorism Expo"
  },
  {
    id: 'calendar05',
    link: 'https://beautyshow.top-link.com.tw',
    image_url: 'https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2023_beautyshow_BN.jpg',
    content: "Taipei Int'l Beauty Show"
  },
  {
    id: 'calendar06',
    link: 'https://buddhismexpo.top-link.com.tw',
    image_url: 'https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2023_buddhismexpo_BN.jpg',
    content: "Taipei Int'l Buddhist Appliances & Sculptures Exhibition"
  },
  {
    id: 'calendar07',
    link: 'javascript:alert("Coming soon!")',
    image_url: 'https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2023_veg_BN.jpg',
    content: "Taipei International Vegetarian Exhibition"
  },
  {
    id: 'calendar08',
    link: 'https://teaculture.top-link.com.tw',
    image_url: 'https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2023_teaculture_BN.jpg',
    content: "Taipei Int'l Tea Culture Expo"
  },
  {
    id: 'calendar09',
    link: 'https://www.tite.com.tw/en/',
    image_url: 'https://cdn.top-link.com.tw/uploadfiles/99/upload/images/2023_TITE_BN.jpg',
    content: "Taiwan International Tourism Expo"
  },
  // {
  //   id: 'calendar10',
  //   link: '',
  //   image_url: '',
  //   content: ""
  // },
]



// WEBPACK FOOTER //
// ./src/plugins/calendars.js